<template>
  <!-- <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </nav> -->
  <router-view />
</template>

<script>
export default {
  data() {
    return {
      data: 1,
    }
  },
  // 实例生成前
  beforeCreate() {
    // if (!this.$Token.JSESSIONID && !["/login", "/userRegister", "/success", "/noDataView", "/deoms"].includes(location.pathname)) {
    if (this.data == 1) {
      this.$router.push("/login");
    }
  }
}
</script>

<style lang="scss">
html,
body,
#app {
  height: 100vh;
  margin: 0;
  padding: 0;
  width: 100vw;
}
</style>
